import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    /**
     * @param   {Object}    options
     * @param   {Function}  callback
     */
    getPhotos : function(options = {}, callback) {
        requestManager.request({
            url: 'portal/user/album/photo',
            data: options
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data.records);
        });
    },


};
